import { render, staticRenderFns } from "./SmartGrabber.vue?vue&type=template&id=db52e3bc&scoped=true&"
import script from "./SmartGrabber.vue?vue&type=script&lang=js&"
export * from "./SmartGrabber.vue?vue&type=script&lang=js&"
import style0 from "./SmartGrabber.vue?vue&type=style&index=0&id=db52e3bc&lang=scss&scoped=true&"
import style1 from "./SmartGrabber.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db52e3bc",
  null
  
)

export default component.exports